module.exports = __webpack_public_path__ + "static/media/confirm.02623b7c.svg";